import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import ProductDetailUnitInfo from '../../../../../../ProductDetailUnitInfo/ProductDetailUnitInfo.js';
import { PackageQuantityDropdown } from '../../../../../Components/PackageQuantityDropdown/PackageQuantityDropdown.js';
import { joinExistingStrings } from './helpers/join-existing-strings.js';
import PackageQuantity$1 from './PackageQuantity.js';
import { PriceAside } from './PriceAside.js';
import { usePackageQuantity } from './usePackageQuantity.js';

const PackageQuantityContainer = ({ onChange , packageTypes , selectedSize  })=>{
    const { getLabel  } = useIntl();
    const mapper = (pack, labels, currency)=>{
        var ref;
        const price = pack.price;
        const value = pack.packageQuantity.toString();
        return {
            label: `${value} ${labels.lenses}`,
            value,
            subtext: joinExistingStrings([
                labels.perBoxLabel,
                labels.perEye
            ], ', '),
            aside: /*#__PURE__*/ React__default.createElement(PriceAside, {
                value: price.value.centAmount,
                currency: currency,
                discountValue: price === null || price === void 0 ? void 0 : (ref = price.discounted) === null || ref === void 0 ? void 0 : ref.value.centAmount,
                asideLabel: labels.perEye
            })
        };
    };
    const packageQuantityLabel = getLabel('products.contactLenses.boxQuantity');
    const { labels: labels1 , packageQuantities  } = usePackageQuantity(packageTypes, mapper);
    return /*#__PURE__*/ React__default.createElement(PackageQuantity$1, {
        packageQuantities: packageQuantities,
        item: /*#__PURE__*/ React__default.createElement(ProductDetailUnitInfo, {
            amount: +packageQuantities[0].value,
            valueUnits: {
                singular: labels1.lens,
                plural: labels1.lenses
            },
            perBox: packageQuantities[0].subtext
        }),
        dropdown: /*#__PURE__*/ React__default.createElement(PackageQuantityDropdown, {
            label: packageQuantityLabel,
            title: packageQuantities[0].value,
            items: packageQuantities,
            selectedSize: selectedSize,
            onChange: onChange
        })
    });
};
var PackageQuantity = PackageQuantityContainer;

export { PackageQuantity as default };
//# sourceMappingURL=PackageQuantityContainer.js.map
